var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.dynamicClasses.wrapper },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeMenu,
              expression: "closeMenu",
            },
          ],
          ref: "button",
          class: _vm.dynamicClasses.button,
          attrs: {
            type: "button",
            id: _vm.buttonUid,
            "aria-haspopup": "true",
            "aria-label": _vm.label,
            "aria-expanded": _vm.open.toString(),
            "aria-controls": _vm.menuUid,
            "aria-hidden": _vm.isDisabled.toString(),
            disabled: _vm.isDisabled,
          },
          on: { click: _vm.onClick, keydown: _vm.onKeydown },
        },
        [
          _vm._t("default"),
          _c("CardBrandArrow", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasMultipleBrands,
                expression: "hasMultipleBrands",
              },
            ],
            attrs: { activated: _vm.hasMultipleBrands && _vm.open },
          }),
        ],
        2
      ),
      _c("CardBrandSelectorMenu", {
        ref: "menu",
        attrs: {
          "aria-hidden": (!_vm.open).toString(),
          "selector-context": _vm.selectorContext,
          open: _vm.open,
          "button-uid": _vm.buttonUid,
          "menu-uid": _vm.menuUid,
          "brand-objects": _vm.brandObjects,
        },
        on: {
          close: function ($event) {
            return _vm.closeMenu(true)
          },
          "user-action": _vm.onUserAction,
        },
        model: {
          value: _vm.selectedBrand,
          callback: function ($$v) {
            _vm.selectedBrand = $$v
          },
          expression: "selectedBrand",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }